export type VersionType = {
  title: string;
  status: string;
  adopted_date: string;
  university: string;
  version_number: any;
  display_version: string;
};
export const EmptyVersion: VersionType = {
  title: "",
  status: "",
  adopted_date: "",
  university: "",
  version_number: 0,
  display_version: "",
};
